import { render, staticRenderFns } from "./GetTextModal.vue?vue&type=template&id=5a94e811"
import script from "./GetTextModal.vue?vue&type=script&lang=js"
export * from "./GetTextModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports